import React from 'react';
import { ResidentDistributionChart } from './charts/ResidentDistributionChart';
import { HealthMetricsChart } from './charts/HealthMetricsChart';
import { MedicationAdherenceChart } from './charts/MedicationAdherenceChart';
import { StaffingLevelsChart } from './charts/StaffingLevelsChart';
import { DataCard } from './DataCard';
import { UserIcon, ActivityIcon, PillIcon, ClipboardListIcon } from 'lucide-react';
interface DashboardProps {
  activeView: string;
  query: string;
}
export const Dashboard: React.FC<DashboardProps> = ({
  activeView,
  query
}) => {
  return <main className="flex-1 overflow-y-auto bg-gray-50 p-6" data-id="element-85">
      {query && <div className="mb-6 p-4 bg-white rounded-lg shadow" data-id="element-86">
          <h2 className="text-lg font-semibold mb-2" data-id="element-87">Results for: "{query}"</h2>
          <p className="text-gray-600" data-id="element-88">
            Generating insights based on your query. In a complete
            implementation, this would display AI-generated reports and
            visualizations.
          </p>
        </div>}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-89">
        <DataCard title="Total Residents" value="247" change="+3" icon={<UserIcon className="h-6 w-6 text-[#1f58b0]" data-id="element-91" />} data-id="element-90" />
        <DataCard title="Avg. Health Score" value="86%" change="+2.3%" icon={<ActivityIcon className="h-6 w-6 text-[#f97c6b]" data-id="element-93" />} data-id="element-92" />
        <DataCard title="Medication Adherence" value="92%" change="-1.5%" isNegative={true} icon={<PillIcon className="h-6 w-6 text-[#f6d052]" data-id="element-95" />} data-id="element-94" />
        <DataCard title="Care Plans Updated" value="98%" change="+5%" icon={<ClipboardListIcon className="h-6 w-6 text-[#255db7]" data-id="element-97" />} data-id="element-96" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-98">
        <div className="bg-white p-4 rounded-lg shadow" data-id="element-99">
          <h3 className="text-lg font-semibold mb-4" data-id="element-100">Resident Distribution</h3>
          <div className="h-64" data-id="element-101">
            <ResidentDistributionChart data-id="element-102" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow" data-id="element-103">
          <h3 className="text-lg font-semibold mb-4" data-id="element-104">Health Metrics Trends</h3>
          <div className="h-64" data-id="element-105">
            <HealthMetricsChart data-id="element-106" />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-107">
        <div className="bg-white p-4 rounded-lg shadow" data-id="element-108">
          <h3 className="text-lg font-semibold mb-4" data-id="element-109">Medication Adherence</h3>
          <div className="h-64" data-id="element-110">
            <MedicationAdherenceChart data-id="element-111" />
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg shadow" data-id="element-112">
          <h3 className="text-lg font-semibold mb-4" data-id="element-113">Staffing Levels</h3>
          <div className="h-64" data-id="element-114">
            <StaffingLevelsChart data-id="element-115" />
          </div>
        </div>
      </div>
    </main>;
};